import React from 'react'
import { useSelector } from 'react-redux'
import url from 'libraries/front-end-core/core/url'
import { QA_CONTENT, QA_MENU } from 'constants/controllers'
import QaResultsItemExcerpt from 'components/search/results-item/QaResultsItemExcerpt'
import QaResultsItemQuestionContainer from 'redux/containers/components/search/results-item/QaResultsItemQuestionContainer'
import QaResultPathBreadCrumbsContainer from 'redux/containers/components/search/results-item/QaResultPathBreadCrumbsContainer'
import selectFlavour from 'redux/selectors/selectFlavour'

const QaResultsItem = ({
  questionNumber = '',
  question,
  answer,
  path = [],
  truncated = false,
  tocId: focusedId,
  aol
}) => {
  const [section] = path
  if (!section) { return null }
  const sectionId = section.id
  const xmlProps = { sectionId }
  const flavour = useSelector(selectFlavour)
  const questionUrl = url(QA_CONTENT, { aol, flavour, sectionId, focusedId })

  return (
    <li className='mt7 mb3' style={{ position: 'relative' }}>
      {aol && (
        <a
          href={`${url(QA_MENU, { flavour })}#${aol}`}
          className='absolute top0 right0 f7 z5 no-underline pv1 ph4 br1 bg-gains-boro charcoal'
        >
          {aol.toUpperCase()}
        </a>
      )}
      <QaResultsItemQuestionContainer {...{ aol, questionNumber, question, questionUrl, xmlProps }} />
      <QaResultPathBreadCrumbsContainer {...{ aol, path }} />
      <QaResultsItemExcerpt {...{ aol, truncated, answer, xmlProps }} />
    </li>
  )
}

export default QaResultsItem
